module.exports = __webpack_public_path__ + "media/images/icons/lightbulb-fa13c07561546bbf528e86f16d0717da.svg";